export default {"src":"/_next/static/media/report_views.836cc8e0.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};